import React from 'react';
import styled from 'styled-components';

const StyledText = styled.p`
  font-family: ${({ theme: { fonts } }) => fonts.helveticaNeue};
  font-size: 16px;
  font-weight: ${(props) => props.style.fontWeight || props.theme.fontWeights.regular};
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: ${(props) => props.color || props.theme.colors.global.primary1};
  margin: 0px;
  @media (max-width: ${(props) => props.theme.deviceSize.mobileL}) {
    font-size: 10px;
  }
`;

type TextProps = {
  color?: string;
  fontWeight?: number;
};

const BodyParagraph = ({ children, color, fontWeight }: React.PropsWithChildren<TextProps>) => {
  return (
    <StyledText color={color} style={{ fontWeight: fontWeight }}>
      {children}
    </StyledText>
  );
};

export default BodyParagraph;
